export const ROLE_LABEL = { admin: 'Admin', subadmin: 'Subadmin', user: 'Usuario' };

export const buildUserOptions = (people, transactions) => {
  const map = new Map();
  people.forEach((p) => p && !map.has(p.username) && map.set(p.username, { username: p.username, role: p.role }));
  transactions.forEach((t) => !map.has(t.username) && map.set(t.username, { username: t.username, role: null }));
  const order = { admin: 0, subadmin: 1, user: 2 };
  return [...map.values()].sort((a, b) => (order[a.role] ?? 3) - (order[b.role] ?? 3) || a.username.localeCompare(b.username));
};
